// Typed API client generated from doc/openapi.yaml (ARCHITECTURE Stack → API contract).
// Same-origin cookies carry the session; state-changing requests send the CSRF token from the
// meta tag Rails renders in the SPA entry (ADR 0007).
import createFetchClient from 'openapi-fetch'
import createQueryClient from 'openapi-react-query'
import { csrfToken } from './csrf'
import type { paths } from './schema'

const SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS'])

export const fetchClient = createFetchClient<paths>({
  // Same origin as the page (Rails serves the SPA); jsdom needs an absolute base in tests.
  baseUrl: typeof window === 'undefined' ? '/' : window.location.origin,
  credentials: 'same-origin',
  // Look the global up per call instead of capturing it, so tests can swap it.
  fetch: (request) => globalThis.fetch(request),
  headers: { 'Content-Type': 'application/json' },
})

fetchClient.use({
  onRequest({ request }) {
    if (!SAFE_METHODS.has(request.method)) {
      request.headers.set('X-CSRF-Token', csrfToken())
    }
    return request
  },
})

// TanStack Query hooks: api.useQuery('get', '/api/me'), api.useMutation('post', …).
export const api = createQueryClient(fetchClient)
